import { render } from "./DictionaryList.vue?vue&type=template&id=2d9b9516"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/basedata/dictionary/DictionaryList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d9b9516"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d9b9516', __exports__)) {
    api.reload('2d9b9516', __exports__)
  }
  
  module.hot.accept("./DictionaryList.vue?vue&type=template&id=2d9b9516", () => {
    api.rerender('2d9b9516', render)
  })

}


export default __exports__